// Copyright (c) 2015, Mightium Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.mightium) window.mightium = {};

mightium.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

mightium.provide("locals");
mightium.provide("mightium.flags");
mightium.provide("mightium.settings");
mightium.provide("mightium.utils");
mightium.provide("mightium.ui.form");
mightium.provide("mightium.modules");
mightium.provide("mightium.templates");
mightium.provide("mightium.test_data");
mightium.provide("mightium.utils");
mightium.provide("mightium.model");
mightium.provide("mightium.user");
mightium.provide("mightium.session");
mightium.provide("mightium._messages");
mightium.provide("locals.DocType");

// for listviews
mightium.provide("mightium.listview_settings");
mightium.provide("mightium.tour");
mightium.provide("mightium.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
